import {SchemeLink} from '../../../../applink/SchemeLink';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {Text} from '../../../atoms/Text/Text';

export interface KeywordsProps {
  keywords: Array<{
    title: string;
    scheme: string;
  }>;
}

export function Keywords({keywords}: KeywordsProps) {
  return (
    <div className="flex w-full flex-wrap px-18pxr pb-10pxr">
      {keywords.map((keyword, index) => (
        <SchemeLink
          key={`keyword-${index}-${keyword.title}`}
          scheme={keyword.scheme}
          onClick={e => LOG_CLICK_EVENT('테마키워드_클릭', e)}
          {...putTiaraObjectProps({
            click: {
              layer1: '테마키워드',
              ordnum: String(index + 1),
              copy: keyword.title,
            },
          })}
          className="mb-8pxr mr-8pxr"
        >
          <div className="flex h-28pxr items-center rounded-8pxr bg-theme-transparent-10 px-12pxr">
            <Text className="font-small2-bold text-ellipsis text-theme-solid-100 line-clamp-1">
              #{keyword.title}
            </Text>
          </div>
        </SchemeLink>
      ))}
    </div>
  );
}
